/* eslint-disable no-console */
/* eslint-disable max-len */

import {Principle6Label} from '../components/Forms/Constants/PrincipleWisePerformanceDisclosure/QuestionsKeyLabel';

export const frameworkGriSource = (): any[] => {
  return [
    {
      key: '1',
      section: '401-3-e - Female - i',
      question:
        'Total number of Female employees that did return to work after parental leave'
    },
    {
      key: '2',
      section: '401-3-e - Female - ii',
      question:
        'Total number of Female employees that due return to work after parental leave'
    },
    {
      key: '3',
      section: '401-3-e - Male - i',
      question:
        'Total number of Male employees that did return to work after parental leave'
    },
    {
      key: '4',
      section: '401-3-e - Male - ii',
      question:
        'Total number of employees due to return to work after taking parental leave'
    },
    {
      key: '5',
      section: '401-3-f - Female - i',
      question:
        'Total number of Female employees retained 12 months after returning to work following a period of parental leave'
    },
    {
      key: '6',
      section: '401-3-f - Female - ii',
      question: 'Total number of employees returning from parental leave'
    },
    {
      key: '7',
      section: '401-3-f - Male - i',
      question:
        'Total number of Male employees retained 12 months after returning to work following a period of parental leave'
    },
    {
      key: '8',
      section: '401-3-f - Male - ii',
      question: 'Total number of employees returning from parental leave'
    },
    {
      key: '9',
      section: '403-2 (a,b,c)',
      question:
        'Harzard identification, risk assessment, and incident investigation'
    },
    {
      key: '10',
      section: '403-9-iii (a)',
      question:
        'For all employees iii. The number of recordable work-related injuries.'
    },
    {
      key: '11',
      section: '403-9-iii (b)',
      question:
        'For all workers who are not employees but whose work and/or workplace is controlled by the organization iii. The number of recordable work-related injuries.'
    },
    {
      key: '12',
      section: '403-10-ii (a)',
      question:
        'For all employees ii. The number of cases of recordable work-related ill health.'
    },
    {
      key: '13',
      section: '403-10-ii (b)',
      question:
        'For all workers who are not employees but whose work and/or workplace is controlled by the organization ii. The number of cases of recordable work-related ill health.'
    },
    {
      key: '14',
      section: '404-3',
      question:
        'Percentage of employees receiving regular performance and career development reviews:'
    },
    {
      key: '15',
      section: '405-1',
      question:
        'Percentage of employees per employee category in each of the following diversity categories:'
    },
    {
      key: '16',
      section: '406-1-a',
      question:
        'Harzard identification, risk assessment, and incident investigation'
    }
  ];
};

export const frameworkBrsrSource = (): any[] => {
  return [
    {
      key: '1',
      section: 'Section A - 20 a.',
      question:
        'a. Employees and workers (including differently abled):\nTotal Male Employees'
    },
    {
      key: '2',
      section: 'Section A - 20 a.',
      question:
        'a. Employees and workers (including differently abled):\nTotal Female Employees'
    },
    {
      key: '3',
      section: 'Section A - 21',
      question:
        '21. Participation/Inclusion/Representation of women\nTotal Board of Directors'
    },
    {
      key: '4',
      section: 'Section A - 21',
      question:
        '21. Participation/Inclusion/Representation of women\nNo. of Females on Board of Directors'
    },
    {
      key: '5',
      section: 'Section C - P3- E5',
      question:
        'Male Employees due to return to work after taking parental leave in reporting period'
    },
    {
      key: '6',
      section: 'Section C - P3- E5',
      question:
        'Female Employees due to return to work after taking parental leave in reporting period'
    },
    {
      key: '7',
      section: 'Section C - P3- E5',
      question:
        'Male Employees that did return to work after parental leave in reporting period'
    },
    {
      key: '8',
      section: 'Section C - P3- E5',
      question:
        'Female Employees that did return to work after parental leave in reporting period'
    },
    {
      key: '9',
      section: 'Section C - P3- E5',
      question:
        'Male Employees retained 12 months after returning to work following a period of parental leave'
    },
    {
      key: '10',
      section: 'Section C - P3- E5',
      question:
        'Female Employees retained 12 months after returning to work following a period of parental leave'
    },
    {
      key: '11',
      section: 'Section C - P3- E10 b.',
      question:
        '10. Health and safety management system:\nb. What are the processes used to identify work-related hazards and assess risks on a routine and non-routine basis by the entity?'
    },
    {
      key: '12',
      section: 'Section C - P3- E10 c.',
      question:
        '10. Health and safety management system:\nc. Whether you have processes for workers to report the work related hazards and to remove themselves from such risks.'
    },
    {
      key: '13',
      section: 'Section C - P3- E10 d.',
      question:
        '10. Health and safety management system:\nd. Do the employees/ worker of the entity have access to non-occupational medical and healthcare services?'
    },
    {
      key: '14',
      section: 'Section C - P3- E11 b.',
      question: '11 b. Employees\nTotal recordable work-related injuries -'
    },
    {
      key: '15',
      section: 'Section C - P3- E11 b.',
      question: '11 b. Workers\nTotal recordable work-related injuries -'
    },
    {
      key: '16',
      section: 'Section C - P3- E11 d.',
      question:
        '11 d. Employees\nHigh consequence work-related injury or ill-health (excluding fatalities) -'
    },
    {
      key: '17',
      section: 'Section C - P3- E11 d.',
      question:
        '11 d. Workers\nHigh consequence work-related injury or ill-health (excluding fatalities) -'
    },
    {
      key: '18',
      section: 'Section C - P5- E6 b.',
      question:
        '6. Number of Complaints on the following made by employees and workers:\nb. Discrimination at workplace\nFiled during the year'
    }
  ];
};

export const frameworkBrsrSourceTargetCDP = (): any[] => {
  return [
    {
      key: '1',
      section: 'Section C - P6- E7',
      question: `${Principle6Label.P6_QUESTION_7}\n${Principle6Label.P6_HEADING_52}`
    },
    {
      key: '2',
      section: 'Section C - P6- E7',
      question: `${Principle6Label.P6_QUESTION_7}\n${Principle6Label.P6_HEADING_53}`
    },
    {
      key: '3',
      section: 'Section C - P6- E1',
      question: `${Principle6Label.P6_QUESTION_1}\n${Principle6Label.P6_HEADING_6}`
    },
    {
      key: '4',
      section: 'Section C - P6- E1',
      question: `${Principle6Label.P6_QUESTION_1}\n${Principle6Label.P6_HEADING_11}`
    }
  ];
};
